import React from 'react';

import BlockWrapper from './BlockWrapper';

// Utils

import { normalizeNameOfPerson } from '../../../utils/normalize/normalizeNameOfPerson';

const IdsInfo = props => {

    const {
        data,
        id,
        ssapApplicationId,
    } = props;

    const getIds = () => {
        return data
            .taxHousehold
            .householdMember
            .map(hhm => {
                const {
                    applicantGuid,
                    personId,
                    name
                } = hhm;

                return (
                    <div key={`${applicantGuid}_${personId}`}>
                        <span style={{
                            fontSize: '1.2rem'
                        }}>
                            { normalizeNameOfPerson(name) }
                        </span>
                        <span style={{
                            fontSize: '1.2rem',
                            position: 'absolute',
                            left: '250px'
                        }}>
                            ID: &nbsp; { personId }
                        </span>
                        <span style={{
                            fontSize: '1.2rem',
                            position: 'absolute',
                            left: '300px'
                        }}>
                            GUID: &nbsp; { applicantGuid }
                        </span>
                    </div>
                );
            });
    };

    return (
        <BlockWrapper
            id={id}
            additionalStyles={{ width: 450 }}
        >
            <div style={{ fontSize: '1.5rem', marginTop: '1rem' }}>
                SSAP Application ID: &nbsp;
                <strong>
                    {
                        ssapApplicationId
                    }
                </strong>
            </div>
            <div style={{ marginTop: '1rem' }}>
                {
                    getIds()
                }
            </div>
        </BlockWrapper>
    );

};

export default IdsInfo;